import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import CustomHeaderTitle from "../../../components/constants/CustomHeaderTitle";
import HeaderBread from "../../../components/HeaderBread";
import { useDataLayerValue } from "../../../DataLayer/DataLayer";
import Layout from "../../../Layout";

import EditRoleInput from "../../../components/Role/EditRoleInput";
import { getPermission } from "../../../utils/ApiCalls/Permission";

const EditRole = () => {
  const params = useParams();
  const [leads, setLeads] = useState({});

  const [{ userDetails, permission }, dispatch] = useDataLayerValue();
  const navigation = [
    {
      title: "Home",
      route: "/",
    },
    {
      title: "Role List",
      route: "/profile/role",
    },
    {
      title: "Edit Role",
      route: "/profile/role/edit",
    },
  ];
  useEffect(() => {
    getData(params?.id);
  }, [params]);
  useEffect(() => {
    console.log({ permission });
  }, [permission]);

  const getData = async (value) => {
    dispatch({
      type: "SET_LOADING",
      loading: true,
    });
    let data = await getPermission({ search: value });

    console.log({ value });
    if (data.error)
      dispatch({
        type: "SET_ERROR_MESSAGE",
        errMess: { message: data.error, type: "error" },
      });
    else if (data.count === 1) {
      setLeads(data.data[0]);
    }
    dispatch({
      type: "SET_LOADING",
      loading: false,
    });
  };
  return (
    <Layout type={"update_per"} module_data={"Roles"}>
      <CustomHeaderTitle title={"View Role"} />
      <HeaderBread navigation={navigation} title={"View Role"}></HeaderBread>
      <div>{leads && <EditRoleInput roles={leads} />}</div>
    </Layout>
  );
};

export default EditRole;
